import _ from 'lodash';
import { VALUE_IF_ABSENT } from '../../common/constants/Constants';

export const separatedBySlash = (...params) => (
  _.every(params, (p) => _.isEmpty(p))
    ? null
    : params.map((p) => p || VALUE_IF_ABSENT).join(' / ')
);
